/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function DetallesEmpresa({ empresa }) {
  const detalles = [
    { label: "Nombre", value: empresa.nombre },
    { label: "NIT", value: empresa.nit },
    { label: "Email", value: empresa.email },
    { label: "Teléfono", value: empresa.telefono },
    { label: "Descripción", value: empresa.descripcion },
    { label: "Sector / Industria", value: empresa.sector_empresa },
    { label: "Tamaño", value: empresa.tamaño_empresa },
    { label: "Zona Estratégica", value: empresa.zona_estrategicas },
    { label: "Área de Operación", value: empresa.area_operacion },
    { label: "País", value: empresa.pais_operacion },
    { label: "Ciudad", value: empresa.ciudad_operacion },
    { label: "Estado", value: empresa.estado_empresa },
    { label: "Fecha de Creación", value: empresa.fecha_creacion },
  ];

  return (
    <MDBox p={3}>
      <Grid container spacing={2}>
        {detalles.map((detalle, index) => (
          <Grid item xs={12} sm={6} key={index}>
            <MDBox mb={2}>
              <MDTypography variant="caption" color="text" fontWeight="bold" textTransform="uppercase">
                {detalle.label}
              </MDTypography>
              <MDTypography variant="body2" fontWeight="regular">
                {detalle.value}
              </MDTypography>
            </MDBox>
          </Grid>
        ))}
      </Grid>
    </MDBox>
  );
}

// Typechecking props for the DetallesEmpresa
DetallesEmpresa.propTypes = {
  empresa: PropTypes.shape({
    nombre: PropTypes.string.isRequired,
    nit: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    telefono: PropTypes.string.isRequired,
    descripcion: PropTypes.string.isRequired,
    sector_empresa: PropTypes.string.isRequired,
    tamaño_empresa: PropTypes.string.isRequired,
    zona_estrategicas: PropTypes.string.isRequired,
    area_operacion: PropTypes.string.isRequired,
    pais_operacion: PropTypes.string.isRequired,
    ciudad_operacion: PropTypes.string.isRequired,
    estado_empresa: PropTypes.string.isRequired,
    fecha_creacion: PropTypes.string.isRequired,
  }).isRequired,
};

export default DetallesEmpresa;